import bgcolors from "../partials/bgcolors";

const settings = {
    label: "Newsletter",
    name: "newsletter",
    file: "site/data/newsletter.yaml",
    i18n: true,
    fields: [
        {
            label: "Newsletter footer active",
            name: "newsletter_active",
            hint: "Activate to show newsletter in footer",
            widget: "boolean",
            required: false,
            i18n: true,
        },
        {
            label: "Title",
            name: "title",
            widget: "string",
            required: false,
            i18n: true
        },
        {
            label: "Body",
            name: "body",
            widget: "markdown",
            required: false,
            i18n: true
        },
        ...bgcolors
    ]
}

export default settings;
